<template>
  <div class="p-5 pb-6 card border-rad-1-2">
    <div>
      <QuestionResponseBars
        :display-data="displayData"
        :assigned-colors="assignedColors"
      />
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import { getMetrics } from '@frontend/api/api.js';
import QuestionResponseBars from '@frontend/ui/components/institutional_questionnaire/QuestionResponseBars.vue';


export default {
  name: 'ValuesWizardResults',
  components: { QuestionResponseBars },
  props: ['prospects', 'assignedColors'],
  data() {
    return { displayData: [] };
  },
  computed: {
    /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  async created() {
    console.log('PROSPECTS', this.prospects);
    const metricCounts = {};
    this.prospects.forEach(prospect => {
      prospect.screen_sets.forEach(screenSet => { // to handle the edge case where values aren't coming from wizard
        screenSet?.metrics?.forEach(metric => {
          const currentMetricCountItem = metricCounts[metric.metric_description];
          const prospectName = `${prospect.first_name} ${prospect.last_name}`;
          metricCounts[metric.metric_description] = {
            count: currentMetricCountItem ? currentMetricCountItem.count + 1 : 1,
            prospects: currentMetricCountItem?.prospects ? [...currentMetricCountItem.prospects, prospectName] : [prospectName],
          };
        });
      });
    });
    console.log('METRIC COUNT', metricCounts);

    const metricsFromServer = (await getMetrics()).data.metrics;
    console.log('METRICS FROM SERVER', metricsFromServer);
    const metricHash = {};
    metricsFromServer.forEach(metric => {
      metricHash[metric.id] = metric;
    });
    Object.keys(metricCounts).forEach(key => {
      metricCounts[key] = { ...metricCounts[key], ...metricHash[key] };
    });
    console.log('METRIC INFO', metricCounts);
    this.displayData = Object.keys(metricCounts).map(key => {
      const metricCount = metricCounts[key];
      return {
        pct: (metricCount.count / this.prospects.length) * 100,
        names: metricCount.prospects,
        choice: metricCount.name,

      };
    });
    console.log('DISPLAY DATA', this.displayData);
  },
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
